module.exports = __webpack_public_path__ + "static/media/section_1_B.8652a77d.png";